<template>
  <div id="about-content" class="container">
    <h2 id="history">History</h2>
    <p>Founded over 35 years ago, NIC INDUSTRIES INC<sup>®</sup>'s vision was to manufacture coating products that would truly have a
      global impact. NIC now manufactures industry-leading coatings that are distributed and sold in nearly 90 countries
      around the world. CERAKOTE<sup>®</sup>, <span v-html="$root.domainTrademark"></span>, and Performance Materials operate as separate divisions of NIC which has grown to be included in the top 25 largest paint and coating manufacturers in the United States. NIC's
      customer base is as wide as its geographical impact, with applications in technology, aerospace, sporting goods, and
      the automotive industry.</p>

    <h2 id="mission">Mission</h2>
    <p>A relentless pursuit to provide market-leading coating technologies with an unyielding passion to never settle.</p>

    <h2 id="core-values">Core Values</h2>
    <div class="cv-background">
      <h3><span class="subtitle">Integrity</span></h3>
    </div>
    <p class="subheadingDesc">An uncompromisable commitment to integrity is paramount to long-term success; victory
      without it is hollow and short-lived.</p>
    <div class="cv-background">
      <h3><span class="subtitle">Development</span></h3>
    </div>
    <p class="subheadingDesc">Continuous professional growth of our team is crucial to maximizing excellence, innovation,
      and organizational resilience.</p>
    <div class="cv-background">
      <h3><span class="subtitle">Stewardship</span></h3>
    </div>
    <p class="subheadingDesc">We must be good stewards of the trust we have earned from our customers, employees, and
      vendors.</p>
    <div class="cv-background">
      <h3><span class="subtitle">Technology</span></h3>
    </div>
    <p class="subheadingDesc">Advancing core technologies through prioritized, focused investment is vital to the success
      and endurance of our company and our customers.</p>
    <div class="cv-background">
      <h3><span class="subtitle">Investment</span></h3>
    </div>
    <p class="subheadingDesc">Investment of all company resources must be made with calculated planning to achieve an
      intentional outcome.</p>

    <h2 id="corp-governance">Corporate Governance</h2>
    <p>NIC's shareholders are focused on long-term investments to further the corporate mission. Supported by an
      experienced Board of Directors, the Executive Leadership and Management Teams take an active role in advancing these
      strategic initiatives. All levels of leadership are aligned in a culture of planning and executing investments for
      the long term.</p>

    <h2 id="facility-location">Facility & Location</h2>
    <p>Headquartered on 18 acres in Southern Oregon, NIC operates several facilities that include nearly 100,000 square
      feet of manufacturing space, a state-of-the-art polymer production plant, training facilities, robotics integration
      group, Research & Development, and all our business support services. We take pride in manufacturing our products in
      the United States.</p>

    <h2 id="foundation">The Foundation of Freedom</h2>
    <p>We believe our customers ultimately benefit from an open and free market that drives innovation through fierce
      competition.</p>

    <a href="https://www.nicindustries.com" target="_blank">
      <img class="center" src="/img/about_us_logos_dark.svg"
        :title="`NIC INDUSTRIES INC® brands, CERAKOTE® and ${$root.domainName}`"
        :alt="`NIC INDUSTRIES INC® brands, CERAKOTE® and ${$root.domainName}`">
    </a>
  </div>
</template>

<script>
export default {
  name: 'about',
};
</script>

<style lang="scss" scoped>
#about-content {
  background-color: rgb(242, 242, 242);
  padding: 0 110px 25px 110px;


  #history::after {
    content: 'History';
  }

  #mission::after {
    content: 'Mission';
  }

  #core-values::after {
    content: 'Core Values';
  }

  #corp-governance::after {
    content: 'Corporate Governance';
  }

  #facility-location::after {
    content: 'Facility & Location';
  }

  #foundation::after {
    content: 'The Foundation of Freedom';
  }

  p {
    color: rgb(57, 57, 57);
    font-size: 2rem;
    margin-bottom: 30px;
    margin-top: 0px;
  }

  p.subheadingDesc {
    margin-top: 5px;
  }

  h3 {
    color: rgb(58, 131, 196);
    font-size: 2.2rem;
    font-weight: 700;
    padding: 5px 5px 5px 20px;
    text-transform: uppercase;
  }

  h2 {
    color: rgb(58, 131, 196);
    font-size: 3.5rem;
    font-weight: 700;
    margin-bottom: -10px;
  }

  h3>span.subtitle {
    color: white;
  }

  h2::after {
    display: flex;
    transform: rotateX(180deg);
    background-image: linear-gradient(180deg,
        rgba(58, 131, 196, 0) 20%,
        rgba(58, 131, 196, 0.25));
    -webkit-background-clip: text;
    color: transparent;
    margin-top: -15px;
  }

  .cv-background {
    background-color: rgb(58, 131, 196);
    width: 300px;
    color: white;
  }

  .center {
    margin: 0 auto;
    width: 40%;
    display: block;
  }

  @media screen and (max-width: 480px) {
    padding: 10px;

    .center {
      width: 90%;
    }
  }
}
</style>
